import { lazy } from 'react'
import { Navigate, type RouteObject } from 'react-router-dom'

const MasterDataHubPage = lazy(() => import('./pages/master-data-hub'))
const RawMaterialPage = lazy(() => import('./pages/raw-material'))
const SpecDetailDrawerPage = lazy(() => import('./pages/raw-material/features/spec-detail-drawer'))
const SupplierPage = lazy(() => import('./pages/supplier'))
const CustomerListPage = lazy(() => import('./pages/customer/features/customer-list'))
const CreateCustomerPage = lazy(() => import('./pages/customer/features/create-customer'))
const DetailCustomerPage = lazy(() => import('./pages/customer/features/detail-customer'))
const EditCustomerPage = lazy(() => import('./pages/customer/features/edit-customer'))
const MasterUnitPage = lazy(() => import('./pages/master-unit'))
const MasterReasonPage = lazy(() => import('./pages/master-reason'))
const MasterSlaPage = lazy(() => import('./pages/master-sla'))
const MasterPalletPage = lazy(() => import('./pages/master-pallet'))
const MasterSkuPage = lazy(() => import('./pages/master-sku'))
const MasterBomPage = lazy(() => import('./pages/master-bom'))
const MasterLocationPage = lazy(() => import('./pages/master-location'))
const MasterAreaPage = lazy(() => import('./pages/master-area'))

const masterDataRoutes: RouteObject[] = [
  {
    path: 'master-data',
    children: [
      {
        index: true,
        element: <MasterDataHubPage />
      },
      {
        path: 'hub',
        element: <MasterDataHubPage />
      },
      {
        path: 'master-sku-fg',
        element: <MasterSkuPage />
      },
      {
        path: 'master-raw-material',
        children: [
          {
            index: true,
            element: <RawMaterialPage />
          },
          {
            path: 'spec-detail',
            element: <SpecDetailDrawerPage />
          }
        ]
      },
      {
        path: 'mst-03a',
        element: <SpecDetailDrawerPage />
      },
      {
        path: 'master-bom',
        element: <MasterBomPage />
      },
      {
        path: 'master-supplier',
        element: <SupplierPage />
      },
      {
        path: 'master-customer',
        children: [
          {
            index: true,
            element: <CustomerListPage />
          },
          {
            path: 'add',
            element: <CreateCustomerPage />
          },
          {
            path: ':id',
            element: <DetailCustomerPage />
          },
          {
            path: ':id/edit',
            element: <EditCustomerPage />
          }
        ]
      },
      {
        path: 'master-lokasi',
        element: <MasterLocationPage />
      },
      {
        path: 'master-area',
        element: <MasterAreaPage />
      },
      {
        // "Master Mesin Produksi" (BA MST-07) digantikan Master Area; alamat lama tetap sampai.
        path: 'master-mesin',
        element: <Navigate to='../master-area' replace />
      },
      {
        path: 'master-sla',
        element: <MasterSlaPage />
      },
      {
        path: 'master-alasan-ng',
        element: <MasterReasonPage />
      },
      {
        path: 'master-unit',
        element: <MasterUnitPage />
      },
      {
        path: 'master-pallet',
        element: <MasterPalletPage />
      }
    ]
  },
  {
    path: 'mst-03a',
    element: <SpecDetailDrawerPage />
  }
]

export default masterDataRoutes
